import React, { Component } from "react";
import { debounce } from "lodash";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Loader from "../general/Loader";
import { formatCurrency, getLink, money, permisions } from "../../utils/helpers";
import { Link } from "react-router-dom";
import { auth } from "../../utils/auth";
import ReporteForm from "./ReporteForm";
import Enviar from "./Enviar";
import ProductoFotos from "./ProductoFotos";
import FiltersContainer from "../general/FiltersContainer";
import PageHeader from "../general/PageHeader";
import ProductCatalogueExportForm from './ProductCatalogueExportForm';
import CategoriasSelect from "../general/CategoriasSelect";
import CategoriasChips from "../general/CategoriasChips";
import { aplanarArbol, gruposDeRespuesta } from "../../utils/categorias";

const queryDeFiltros = (filtros) =>
	Object.keys(filtros)
		.map((fil) => `${fil}=${filtros[fil]}`)
		.join("&");

class Productos extends Component {
	state = {
		productos: {},
		producto: {},
		almacenes: [],
		ubicaciones: [],
		arbolGrupos: [],
		categoriasFiltro: [],
		suplidores: [],
		links: null,
		showOperacionesInventario: false,
		showCreate: false,
		showEnviar: false,
		showFotos: false,
		showExportCatalogue: false,
		loading: true,
		filtros: {},
		filtrosQuery: "",
	};
	componentDidMount() {
		this.getProductos();
		this.getTable("almacenes");
		this.getTable("ubicaciones");
		this.getArbolGrupos();
		this.getSuplidores();
	}
	getArbolGrupos = async () => {
		const respuesta = await this.props.request("grupos?arbol=1");

		this.setState({ arbolGrupos: gruposDeRespuesta(respuesta) });
	};
	getProductos = async (url = null) => {
		url = url ? url + "&limit=20" : "productos?limit=20";
		const productos = await this.props.request(url);

		if (productos.data) {
			this.setState({
				productos: productos.data,
				meta: productos.meta,
				links: productos.links,
				loading: false,
			});
		}
	};
	getTable = async (table) => {
		const response = await this.props.request(table);

		if (response.data && response.data.length) {
			this.setState({
				[table]: response.data,
			});
		}
	};
	getSuplidores = async () => {
		const response = await this.props.request('contactos?tipo=proveedor&limit=1000');

		if (response.data && response.data.length) {
			this.setState({
				suplidores: response.data,
			});
		}
	};
	toggleCreateModal = () => {
		this.setState({
			showCreate: !this.state.showCreate,
			producto: {},
		});
	};
	toggleEnviarModal = (producto) => {
		this.setState({
			showEnviar: !this.state.showEnviar,
			producto: producto,
		});
	};
	toggleOperacionesInventarioModal = (producto) => {
		this.setState({
			showOperacionesInventario: !this.state.showOperacionesInventario
		});
	};
	toggleFotosModal = (producto) => {
		this.setState({
			showFotos: !this.state.showFotos,
			producto: producto,
		});
	};
	toggleCatalogueModal = () => {
		this.setState({
			showExportCatalogue: !this.state.showExportCatalogue,
		});
	};
	onFiltroChange = (value, filtro) => {
		this.setState((state) => {
			const filtros = { ...state.filtros, [filtro]: value };

			return { filtros, filtrosQuery: `?${queryDeFiltros(filtros)}` };
		}, this.buscarConFiltros);
	};
	// El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
	// era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
	// descartaba el primero junto con su valor.
	buscarConFiltros = debounce(() => {
		this.getProductos(`productos${this.state.filtrosQuery}`);
	}, 500);
	onCategoriasChange = (ids) => {
		this.setState({ categoriasFiltro: ids });

		// El backend expande los descendientes de cada id, no hace falta mandarlos.
		this.onFiltroChange(ids.length ? ids.join(",") : "todos", "grupo");
	};
	render() {
		const {
			productos,
			almacenes,
			ubicaciones,
			arbolGrupos,
			categoriasFiltro,
			suplidores,
			loading,
			filtrosQuery,
		} = this.state;
		return (
			<div>
				<PageHeader
					title="Productos/Servicios"
					titleDescription="Registre productos y servicios para venta."
				>
					{auth.can(permisions.movimientoMasivos) && (<Link to={getLink(`/productos/inventario-masivo`)}className="au-btn au-btn-icon au-btn-filter m-r-10">
						<i className="zmdi zmdi-store"></i> Movimientos Masivo
					</Link>)}

					{auth.can(permisions.exportarCatalogo) && (<button onClick={() => this.toggleCatalogueModal()} className="au-btn au-btn-icon au-btn-filter m-r-10">
					<i className="zmdi zmdi-download"></i> Exportar Cat&aacute;logo
					</button>)}

					<div className="dropdown m-r-10">
						<button className="au-btn au-btn-icon au-btn-filter">
							<i className="zmdi zmdi-print"></i> Reportes
						</button>
						<ul
							style={{ right: "0", left: "auto" }}
							className="dropdown-menu"
						>
							{auth.can(permisions.reporteInventarioProductosRealizarInventario) && <li>
								<Link
									to={getLink(
										`/imprimir/realizar-inventario${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Realizar Inventario
								</Link>
							</li>}
							{auth.can(permisions.reporteInventarioProductosInventario) && <li>
								<Link
									to={getLink(
										`/imprimir/productos${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Inventario
								</Link>
							</li>}
							{auth.can(permisions.reporteInventarioProductosReordern) && <li>
								<Link
									to={getLink(
										`/imprimir/reorden${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Reorden
								</Link>
							</li>}
							{auth.can(permisions.reporteInventarioProductosBalance) && <li>
								<Link
									to={getLink(
										`/imprimir/reportes?reporte=balance-inventario${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Balance Inventario
								</Link>
							</li>}
							{auth.can(permisions.reporteInventarioProductosOperaciones) && <li>
								<button
									onClick={this.toggleOperacionesInventarioModal}
									className="dropdown-item"
								>
									Operaciones de Inventario
								</button>
							</li>}
							{auth.can(permisions.reporteInventarioProductosInventarioCentas) && <li>
								<Link
									to={getLink(
										`/imprimir/ventas${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Inventario Ventas
								</Link>
							</li>}
							{auth.can(permisions.reporteInventarioProductosPorSuplidor) && <li>
								<Link
									to={getLink(
										`/imprimir/productos-suplidor${filtrosQuery}`
									)}
									target="_blank"
									className="dropdown-item"
								>
									Productos por Suplidor
								</Link>
							</li>}
						</ul>
					</div>

					{auth.can(permisions.crearProductos) && (
						<Link
							to={getLink(`/productos/crear`)}
							className="au-btn au-btn-icon au-btn--green au-btn--small"
						>
							<i className="zmdi zmdi-plus" />
							Añadir Producto/servicio
						</Link>
					)}
				</PageHeader>
				<FiltersContainer>
					<div className="col-md-3">
						<label htmlFor="search">Buscar</label>
						<input
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "buscar")
							}
							type="search"
							placeholder="Buscar..."
							className="form-control"
							name="buscar"
						/>
					</div>
					<div className="col-md-2">
						<label htmlFor="almacen">Almacén</label>
						<select
							className="form-control"
							name="almacen"
							id="almacen"
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "almacen")
							}
						>
							<option value="todos">Todos</option>
							{almacenes.map((almacen) => (
								<option key={almacen.id} value={almacen.id}>
									{almacen.nombre}
								</option>
							))}
						</select>
					</div>
					<div className="col-md-2">
						<label htmlFor="almacen">Ubicación</label>
						<select
							className="form-control"
							name="ubicacion"
							id="ubicacion"
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "ubicacion")
							}
						>
							<option value="todos">Todas</option>
							{ubicaciones.map((ubicacion) => (
								<option key={ubicacion.id} value={ubicacion.id}>
									{ubicacion.nombre}
								</option>
							))}
						</select>
					</div>
					<div className="col-md-3">
						<label htmlFor="categorias-filtro">Categorías</label>
						<CategoriasSelect
							arbol={arbolGrupos}
							valor={categoriasFiltro}
							onChange={this.onCategoriasChange}
							inputId="categorias-filtro"
							placeholder="Todas"
						/>
					</div>
					<div className="col-md-2">
						<label htmlFor="tipo">Tipo</label>
						<select
							className="form-control"
							name="tipo"
							id="tipo"
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "tipo")
							}
						>
							<option value="todos">Todos</option>
							<option value="producto">Productos</option>
							<option value="servicio">Servicios</option>
							<option value="grupo">Grupos</option>
						</select>
					</div>
				</FiltersContainer>
				<div className="row">
					<div className="col-md-12">
						<div>
							{loading && <Loader />}
							{!productos.length ? (
								<div>
									{!loading && (
										<div>
											Todavía no hay productos creados.
										</div>
									)}
								</div>
							) : (
								<div className="table-data">
									<table className="table table-data2">
										<thead>
											<tr>
												<th>Ref.</th>
												<th>Nombre</th>
												<th>Almacén</th>
												<th>Ubicación</th>
												<th>Cantidad</th>
												<th>Precio Venta</th>
												<th>Total</th>
												<th>Descripción</th>
												<th />
											</tr>
										</thead>
										<tbody>
											{productos.map((producto) => (
												<tr
													className="tr-shadow"
													key={producto.id}
												>
													<td>
														{producto.referencia}
													</td>
													<td>
                                                        {producto.nombre}
                                                        <div><CategoriasChips
															producto={producto}
														/></div>
                                                    </td>
													<td style={{ width: 130 }}>
														{producto.almacen &&
															producto.almacen
																.nombre}
													</td>
													<td style={{ width: 130 }}>
														{producto.ubicacion &&
															producto.ubicacion
																.nombre}
													</td>
													{producto.inventariable ? (
														<td>
															{producto.cantidad}{" "}
															{producto.unidad}
														</td>
													) : (
														<td>&infin;</td>
													)}
													<td>
														{formatCurrency(
															money(producto.precio)
														)}
													</td>
													<td>
														{formatCurrency(
															money(producto.precio *
																producto.cantidad)
														)}
													</td>
													<td>
														<div style={{maxHeight: "50px", overflow: "hidden", textOverflow: "ellipsis"}}>{producto.descripcion}</div>
													</td>
													<td>
														<div className="table-data-feature">
															{producto.fotos
																.length > 0 && (
																<button
																	title="Ver Fotos"
																	onClick={() =>
																		this.toggleFotosModal(
																			producto
																		)
																	}
																	className="item"
																>
																	<i className="fas fa-eye"></i>
																</button>
															)}
															{producto.tipo ===
																"producto" &&
																producto.cantidad >
																	0 && (
																	<button
																		title="Enviar"
																		onClick={() =>
																			this.toggleEnviarModal(
																				producto
																			)
																		}
																		className="item"
																	>
																		<i className="zmdi zmdi-truck" />
																	</button>
																)}
															{auth.can(permisions.editarProductos) && (<Link
																data-toggle="tooltip"
																data-placement="top"
																title="Editar"
																data-original-title="Edit"
																className="item"
																to={getLink(
																	`/productos/${producto.id}/informacion`
																)}
															>
																<i className="zmdi zmdi-edit" />
															</Link>)}
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
									{this.state.links && (
										<Pagination
											links={this.state.links}
											meta={this.state.meta}
											getData={this.getProductos}
										/>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				<Modal
					show={this.state.showEnviar}
					blank={true}
					toggle={() => {
						this.setState({
							showEnviar: !this.state.showEnviar,
						});
					}}
				>
					<Enviar
						toggle={() => {
							this.setState({
								showEnviar: !this.state.showEnviar,
							});
						}}
						producto={this.state.producto}
						getProductos={this.getProductos}
						almacenes={almacenes}
					/>
				</Modal>
				<Modal
					show={this.state.showOperacionesInventario}
					blank={true}
					size={"600px"}
					toggle={() => {
						this.setState({
							showOperacionesInventario: !this.state.showOperacionesInventario,
						});
					}}
				>
					<ReporteForm
						toggle={() => {
							this.setState({
								showOperacionesInventario: !this.state.showOperacionesInventario,
							});
						}}
					/>
				</Modal>
				{this.state.producto?.fotos && (
					<Modal
						show={this.state.showFotos}
						blank={true}
						toggle={() => {
							this.setState({
								showFotos: !this.state.showFotos,
							});
						}}
					>
						<ProductoFotos
							toggle={() => {
								this.setState({
									showFotos: !this.state.showFotos,
								});
							}}
							fotos={this.state.producto.fotos.map(
								(foto) => foto.url
							)}
						/>
					</Modal>
				)}
				<Modal
					show={this.state.showExportCatalogue}
					blank={true}
					toggle={() => {
						this.setState({
							showExportCatalogue: !this.state.showExportCatalogue,
						});
					}}
				>
					<ProductCatalogueExportForm
						toggle={() => {
							this.setState({
								showExportCatalogue: !this.state.showExportCatalogue,
							});
						}}
						grupos={aplanarArbol(arbolGrupos)}
						suplidores={suplidores}
						request={this.props.request}
					/>
				</Modal>
			</div>
		);
	}
}

export default withRequest(Productos);
